module.exports = __webpack_public_path__ + "img/ic-home-blue.dcf4f838.svg";